import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GOHONZON_TYPE } from "../contants";
import {
  GOHONZON_OKATAKI_FIELDS,
  GOHONZON_OKATAKI_INTERVIEW_FIELDS,
  GOHONZON_OMAMORI_FIELDS,
} from "../contants/formFields";
import { PREVIEW } from "../contants/gohonzon";
import {
  getFieldsWithValue,
  getOkatakiAnswerFields,
  getReturnHandoverFields,
} from "../pages/gohonzon/GohonzonSubmission/helper";
import { selectAllSIUsers } from "../redux/selectors/user";

function useGohonzon(gohonzonType) {
  const { type, preview } = useParams();
  const {
    isDistrictSi,
    isChapterSi,
    isRegionSi,
    isHelpDesk,
    isZoneSi,
    isHelpDeskAdmin,
  } = useSelector(selectAllSIUsers);
  const isInterviewRegionSi = isRegionSi && type === `interview`;
  const isInterviewZoneSi = isZoneSi && type === `interview`;
  const isReturn = type === "return";
  const isPreview = preview === PREVIEW;
  const isTracking = type === "tracking";

  const showOkatakiForm = () =>
    gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON &&
    !isReturn &&
    !isTracking &&
    (isChapterSi || isRegionSi);

  const showOkatakiFormByMember = () =>
    !isReturn &&
    gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON &&
    (isChapterSi ||
      isInterviewRegionSi ||
      isHelpDesk ||
      isHelpDeskAdmin ||
      isTracking);

  const showOkatakiFormByChapterSi = () =>
    !isReturn &&
    gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON &&
    (isInterviewRegionSi ||
      isHelpDesk ||
      isHelpDeskAdmin ||
      isTracking ||
      (isTracking && isZoneSi));

  const showOkatakiFormByRegionSi = () =>
    !isReturn &&
    gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON &&
    (isHelpDesk || isHelpDeskAdmin || isTracking || (isTracking && isZoneSi));

  const showOmamoriForm = () =>
    gohonzonType === GOHONZON_TYPE.OMAMORI_GOHONZON &&
    !isReturn &&
    isTracking &&
    (isDistrictSi ||
      isChapterSi ||
      isRegionSi ||
      isHelpDesk ||
      isZoneSi ||
      isHelpDeskAdmin ||
      isHelpDesk);

  const showMemberRelationship = () =>
    !isReturn &&
    (isDistrictSi ||
      isHelpDesk ||
      isChapterSi ||
      isRegionSi ||
      isHelpDeskAdmin ||
      (isZoneSi && isTracking) ||
      isTracking);

  const showPlegde = () =>
    gohonzonType === GOHONZON_TYPE.OMAMORI_GOHONZON &&
    (isDistrictSi ||
      isChapterSi ||
      isRegionSi ||
      isHelpDesk ||
      isZoneSi ||
      isHelpDeskAdmin ||
      isTracking ||
      isReturn);

  const showMemberInterviewedForm = () =>
    (gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON && isInterviewRegionSi) ||
    isHelpDesk ||
    isHelpDeskAdmin;
  const showHomeVisitedRecommended = () =>
    (isChapterSi && !isTracking) ||
    isRegionSi ||
    isHelpDesk ||
    isZoneSi ||
    isHelpDeskAdmin;

  const showReturnInReadMode = () => isReturn && isHelpDesk;

  const getInitialFormData = (values) => {
    let result = {};
    if (gohonzonType === GOHONZON_TYPE.OMAMORI_GOHONZON && !isReturn) {
      result = getFieldsWithValue(GOHONZON_OMAMORI_FIELDS, values);
      console.log("result 63", values);
    }
    if (
      gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON &&
      !isDistrictSi &&
      (isChapterSi || isInterviewRegionSi)
    ) {
      result = getOkatakiAnswerFields(GOHONZON_OKATAKI_FIELDS, values);
      console.log("values: ", result);
    }
    if (
      isInterviewRegionSi &&
      gohonzonType === GOHONZON_TYPE.OKATAKI_GOHONZON
    ) {
      result = {
        ...result,
        ...getOkatakiAnswerFields(GOHONZON_OKATAKI_INTERVIEW_FIELDS, values),
      };
    }
    if (isReturn) {
      result = {
        ...result,
        ...getReturnHandoverFields(values),
      };
    }
    console.log("result 89 ", result);
    return result;
  };

  const readOnly =
    isPreview ||
    // (!isInterviewRegionSi && !isChapterSi) ||
    isInterviewZoneSi ||
    showReturnInReadMode() ||
    (gohonzonType === GOHONZON_TYPE.OMAMORI_GOHONZON &&
      (isChapterSi || isRegionSi));

  return {
    readOnly,
    isReturn,
    isPreview,
    showPlegde,
    showOkatakiForm,
    showOmamoriForm,
    isInterviewZoneSi,
    isInterviewRegionSi,
    getInitialFormData,
    showMemberRelationship,
    showMemberInterviewedForm,
    showHomeVisitedRecommended,
    showOkatakiFormByMember,
    showOkatakiFormByChapterSi,
    showOkatakiFormByRegionSi,
  };
}

export default useGohonzon;
